import { useEffect, useState } from "react";
import TabMenuAdmin from "../TabMenuAdmin/TabMenuAdmin";
import TableTechnicalSupport from "./components/TableTechnicalSupport";
import { getAllTechnicalSupportService } from "./services/adminTechnicalSupport.service";
import { ApiTechnicalSupportData } from "./models/technicalSupport.model";
import { Dialog } from "primereact/dialog";
import FormEditTechnicalSupport from "./components/FormEditTechnicalSupport";
import { useNavigate } from "react-router-dom";
import { ToastControlBackendModel } from "../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";
import ToastBackControl from "../../../../components/Sidebar/ToastBackControl/ToastBackControl";

const viewStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .admin-lottery-root-container {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #f8fafc !important;
    min-height: 100vh;
    width: 100%;
    color: #1e293b;
  }

  /* 🧼 LIMPIEZA DE LA TABLA */
  .clean-light-table .p-datatable,
  .clean-light-table .p-datatable-thead > tr > th,
  .clean-light-table .p-datatable-tbody > tr,
  .clean-light-table .p-datatable-tbody > tr > td,
  .clean-light-table .p-datatable-header {
    background-color: #ffffff !important;
    color: #334155 !important;
    border-color: #f1f5f9 !important;
  }

  .clean-light-table .p-datatable-thead > tr > th {
    background-color: #f8fafc !important;
    font-weight: 700 !important;
    color: #1e293b !important;
  }

  .clean-light-table .p-datatable {
    border: none !important;
    box-shadow: none !important;
  }

  .clean-light-table .p-inputtext {
    background-color: #ffffff !important;
    color: #334155 !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 6px;
  }

  /* 🎨 ARREGLO PARA EL DIÁLOGO DE RESPUESTA (image_3994a8.png) */
  /* Forzar el input/textarea a fondo blanco texturizado y letra oscura */
  .custom-reply-dialog .p-inputtext, 
  .custom-reply-dialog textarea {
    background-color: #ffffff !important;
    color: #334155 !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px !important;
    padding: 0.75rem 1rem !important;
    width: 100% !important;
  }

  .custom-reply-dialog .p-inputtext:focus,
  .custom-reply-dialog textarea:focus {
    outline: none !important;
    border-color: #00A86B !important;
    box-shadow: 0 0 0 2px rgba(0, 168, 107, 0.15) !important;
  }

  /* Forzar el botón a color VERDE corporativo */
  .custom-reply-dialog .p-button {
    background-color: #00A86B !important;
    border-color: #00A86B !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    border-radius: 6px !important;
    transition: background-color 0.2s !important;
  }

  .custom-reply-dialog .p-button:hover {
    background-color: #008f5b !important;
    border-color: #008f5b !important;
  }

  /* Estilo cuando el botón está deshabilitado */
  .custom-reply-dialog .p-button:disabled {
    background-color: #cbd5e1 !important;
    border-color: #cbd5e1 !important;
    color: #ffffff !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
  }
`;

function AdminTechnicalSupport(): JSX.Element {
  const isAdminValue = localStorage.getItem("isAdmin");
  const navigate = useNavigate();
  const [technicalSupporDataTable, setTechnicalSupporDataTable] = useState<
    ApiTechnicalSupportData[]
  >([]);
  const [rowData, setRowData] = useState<ApiTechnicalSupportData>();
  const [showDialogAddResponse, setShowDialogAddResponse] = useState(false);
  const [messageBackend, setMessageBackend] =
    useState<ToastControlBackendModel>({
      severityValue: "info",
      detailValue: "",
      lifeValue: 3000,
      validateShowMessage: false,
    });

  const getAllTechnicalSupport = async () => {
    try {
      const response = await getAllTechnicalSupportService();
      if (response) {
        setTechnicalSupporDataTable(response);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (isAdminValue !== "1") {
      navigate("/");
    }
    getAllTechnicalSupport();
  }, []);

  return (
    <div className="admin-lottery-root-container">
      <style>{viewStyles}</style>
      
      <TabMenuAdmin />
      
      <main className="w-full flex flex-column px-3 md:px-5 py-4">
        
        {/* Cabecera Principal */}
        <div className="flex align-items-center justify-content-between pb-4 border-bottom-1 surface-border mb-4">
          <div className="flex align-items-center gap-3">
            <div className="flex align-items-center justify-content-center p-2 border-round-lg shadow-1" style={{ backgroundColor: "#e6faf2", color: "#00A86B" }}>
              <i className="pi pi-comments text-xl"></i>
            </div>
            <div className="flex flex-column justify-content-center">
              <h1 className="text-xl md:text-2xl font-bold m-0 tracking-tight" style={{ color: "#1e293b" }}>
                Reportes a Soporte Técnico
              </h1>
              <p className="text-sm text-500 m-0 mt-1 hidden sm:block">
                Gestiona y responde las solicitudes de soporte y reportes enviados por los usuarios del sistema.
              </p>
            </div>
          </div>
        </div>

        <>
          {messageBackend.validateShowMessage && (
            <ToastBackControl
              validateShowMessage={messageBackend.validateShowMessage}
              detailValue={messageBackend.detailValue}
              lifeValue={messageBackend.lifeValue}
              severityValue={messageBackend.severityValue}
            />
          )}

          {/* Tabla contenedora */}
          <div className="bg-white p-4 border-round-xl shadow-1 w-full clean-light-table">
            <TableTechnicalSupport
              technicalSupporDataTable={technicalSupporDataTable}
              setRowData={setRowData}
              setShowDialogAddResponse={setShowDialogAddResponse}
            />
          </div>

          {/* Diálogo de Respuesta corregido con la clase custom-reply-dialog */}
          {rowData && (
            <Dialog
              header={`Respuesta al reporte #${rowData.idTechnicalSupport}`}
              visible={showDialogAddResponse}
              onHide={() => setShowDialogAddResponse(false)}
              className="w-full max-w-30rem mx-3 custom-reply-dialog"
              breakpoints={{ '960px': '75vw', '641px': '100vw' }}
              draggable={false}
              resizable={false}
              pt={{
                root: { style: { backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1)" } },
                header: { style: { backgroundColor: "#ffffff", color: "#1f2937", borderBottom: "1px solid #e5e7eb", padding: "1.25rem 1.5rem" } },
                content: { style: { backgroundColor: "#ffffff", padding: "1.5rem" } },
                closeButtonIcon: { style: { color: "#1f2937" } }
              }}
            >
              <FormEditTechnicalSupport
                setShowDialogAddResponse={setShowDialogAddResponse}
                idTechnicalSupport={rowData.idTechnicalSupport}
                getAllTechnicalSupport={getAllTechnicalSupport}
                setMessageBackend={setMessageBackend}
              />
            </Dialog>
          )}
        </>
      </main>
    </div>
  );
}

export default AdminTechnicalSupport;